// client/src/components/PrivacyPolicyPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AgreementsPage.css'; // Shared CSS

function PrivacyPolicyPage() {
  const {t} = useTranslation();

  return (
    <div className="policy-page">
      <h1>{t('Agreements.privacyPolicyTitle')}</h1>
      <p>
        {t('Agreements.privacyPolicyPlaceholder')}
      </p>
      {/* Add your actual privacy policy content here */}
    </div>
  );
}

export default PrivacyPolicyPage;